import React from "react";
import {CALENDER_ICON, FAVOURITE_ICON } from "assets/constants/Icons";
import moment from 'moment';

const FavoritesPage = () => {
  return (<>
    {
       (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <div className="col-md-10 sm_device"><i className={`${FAVOURITE_ICON}`}></i> Favourite Page</div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">
              Favourite Page content will Appear here.
            
          </div>
        </div>
      )
    }
  </>);
}

export default FavoritesPage;